const R_ICON = "https://customer-assets-0z36b82j.emergentagent.net/job_order-printing-id/artifacts/oyh0do4z_logo%20rooftop";

export const BrandLogo = ({ logoUrl, imgClassName = "h-9 w-auto" }) => {
  if (logoUrl) {
    return <img src={logoUrl} alt="ROOFTOP PRINT" className={imgClassName} data-testid="brand-logo-img" />;
  }
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo-wordmark">
      <img src={R_ICON} alt="Rooftop Print" className="w-9 h-9 rounded-full object-cover shrink-0" data-testid="brand-logo-icon" />
      <div className="leading-none">
        <span className="font-heading font-extrabold text-lg tracking-tight text-[#00133F]">ROOFTOP</span>
        <span className="font-heading font-extrabold text-lg tracking-tight text-[#F0005A]"> PRINT</span>
      </div>
    </div>
  );
};
